"use client";
import ReactSelect, { components } from "react-select";
import classes from "./DropDown.module.css";
import PropTypes from "prop-types";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { Label } from "../Label";
export const DropDown = ({
  options,
  label,
  labelTwo,
  customStyle,
  disabled,
  value,
  setter,
  noBorder,
  placeholder,
  placeholderColor = "var(--placeholder-color)",
  isMulti,
  style,
  leftIcon,
  Components,
  labelClassName,
  labelStyle,
  indicatorColor = "var(--main-color)",
  indicatorIcon,
  optionLabel,
  optionValue,
  singleValueColor = "var(--black-color)",
  customeClassName = "DropdownOptionContainer",
  className,
  isSearchable,
  CustomOption,
  squared = false,
  error,
  errorText,
  menuPlacement = "auto",
  ...props
}) => {
  const DropdownIndicator = (props) => {
    return (
      <>
        <style>
          {`
            .DropdownOptionContainer__indicator{
            padding: 2px;
            border-radius: 8px;
            height:26px;
            width:26px;
            display:flex;
            align-items:center;
            justify-content:center;
            }
          `}
        </style>
        <components.DropdownIndicator {...props}>
          {props?.selectProps?.menuIsOpen ? (
            indicatorIcon ? (
              indicatorIcon
            ) : (
              <IoIosArrowUp size={18} color={indicatorColor} />
            )
          ) : indicatorIcon ? (
            indicatorIcon
          ) : (
            <IoIosArrowDown size={18} color={indicatorColor} />
          )}
        </components.DropdownIndicator>
      </>
    );
  };

  const dropDownStyle = {
    control: (styles, { isFocused, isDisabled, isSelected }) => ({
      ...styles,
      backgroundColor: isDisabled
        ? "var(--disabled-input-color)"
        : "var(--white-color)",
      padding: "0 4px",
      minHeight: "40px",
      color: "var(--text-color)",
      boxShadow: "none",
      fontFamily: "var(--ff-primary-reg)",
      fontSize: "var(--fs-100)",
      letterSpacing: "1.4",
      cursor: "pointer",
      border: "none",
      borderRadius: "var(--input-border-radius)",
      textTransform: "capitalize",
      border: error ? "1px solid red" : "1px solid var(--input-border-color)",
      ...customStyle,

      ":hover": {
        ...styles[":hover"],
        borderColor: "var(--input-border-color)",
      },
      ":placeholder": {
        ...styles[":placeholder"],
        color: "var(--text-color)",
        fontWeight: "700",
        fontFamily: "var(--ff-primary)",
        fontSize: "var(--fs-100)",
        opacity: 0.4,
      },
      ":active": {
        ...styles[":active"],
        borderColor: "var(--border-color)",
      },
    }),

    menu: (defaultStyles) => ({
      ...defaultStyles,
      backgroundColor: "var(--input-background-color)",
      borderRadius: "var(--input-border-radius)",
    }),
    menuList: (defaultStyles) => ({
      ...defaultStyles,
      padding: "4px",
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        fontFamily: "var(--ff-primary-med)",
        color: placeholderColor,
        opacity: 0.6,
      };
    },

    singleValue: (provided) => ({
      ...provided,
      color: singleValueColor,
    }),

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        borderRadius: "6px",
        fontFamily: isSelected
          ? "var(--ff-primary-semiBold)"
          : "var(--ff-primary-reg)",
        fontSize: "var(--fs-100)",
        textTransform: "capitalize",
        cursor: "pointer",
        color: isSelected ? "var(--main-color)" : "var(--text-color)",
        backgroundColor: isSelected
          ? "color-mix(in srgb, var(--main-color) 14%, white)"
          : isFocused
            ? "color-mix(in srgb, var(--main-color) 7%, white)"
            : "transparent",
        "::after": isSelected
          ? { content: '"✓"', fontSize: "12px" }
          : undefined,
        ":active": {
          ...styles[":active"],
          backgroundColor: "color-mix(in srgb, var(--main-color) 14%, white)",
        },
      };
    },

    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "color-mix(in srgb, var(--main-color) 12%, white)",
        borderRadius: "6px",
        padding: "0 4px",
        fontFamily: "var(--ff-primary-reg)",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "var(--main-color)",
      fontSize: "13px",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "var(--main-color)",
      ":hover": {
        color: "var(--main-color)",
        backgroundColor: "transparent",
      },
    }),
  };

  return (
    <div
      className={`${[classes.Container, className ? className : ""].join(" ")}`}
    >
      <style>{`
        .DropdownOptionContainer__menu {
          margin: 4px 0 0;
          border: 1px solid var(--input-border-color);
          z-index: 2100 !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
          white-space: normal;
          overflow: hidden;
        }
      `}</style>
      {label && (
        <Label
          htmlFor={`dropdown${label}`}
          disabled={disabled}
          style={{ ...labelStyle }}
        >
          {label}
        </Label>
      )}

      <div className={`${[classes.dropdownContainer].join(" ")}`}>
        <ReactSelect
          inputId={`dropdown${label}`}
          value={value}
          onChange={(e) => {
            setter(e);
          }}
          className={`${[classes.reactSelect].join(" ")}`}
          isMulti={isMulti}
          isSearchable={isSearchable}
          isDisabled={disabled}
          placeholder={placeholder}
          options={options}
          styles={{ ...dropDownStyle, ...style }}
          isClearable={false}
          classNamePrefix={customeClassName}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: (e) => DropdownIndicator(e),
            ...(CustomOption && { Option: CustomOption }),
            ...Components,
          }}
          menuPlacement={menuPlacement}
          getOptionLabel={(option) => {
            return optionLabel ? option[optionLabel] : option.label;
          }}
          getOptionValue={(option) =>
            optionValue ? option[optionValue] : option.value
          }
          {...props}
        />
        {leftIcon && <div className={classes.leftIconBox}>{leftIcon}</div>}
        {error && <p className={classes.errorText}>{errorText}</p>}
      </div>
    </div>
  );
};

DropDown.propTypes = {
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  labelTwo: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.object.isRequired,
  setter: PropTypes.object,
  disabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  customStyle: PropTypes.object,
  style: PropTypes.object,
  Components: PropTypes.object,
  labelClassName: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
};

DropDown.defaultProps = {
  placeholder: "sdsad",
  value: "aaaa",
  disabled: false,
  isMulti: false,
  options: [],
  Components: {},
};
